export default "__VITE_ASSET__s6s8Sr0Z__"